import { useSuspenseQuery } from "@tanstack/react-query";
import { orderHistoryClaimApi } from "@/features/my-order/features/order-history/features/claim/api";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import { toCamelKeyObject } from "@/utils/case";
import { GetClaimableProductsResponse } from "@/features/my-order/features/order-history/features/claim/types";

const useGetClaimableProducts = () => {
  const identity = useIdentity();
  const { orderSheetSetId } = useOrderHistoryDetail();

  const companyId = identity?.company?.id;
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];

  const canFetch = orderSheetSetId && companyId && companyType;

  const { data } = useSuspenseQuery({
    queryFn: () => {
      if (!canFetch) return;
      return orderHistoryClaimApi.getClaimableProducts(
        companyType,
        companyId,
        orderSheetSetId
      );
    },
    queryKey: [
      "order-history",
      "claimable-products",
      companyType,
      companyId,
      orderSheetSetId,
    ],
    select: (data) => toCamelKeyObject(data) as GetClaimableProductsResponse,
  });

  return { data };
};

export default useGetClaimableProducts;
